import { render, staticRenderFns } from "./WithdrawalPopup.vue?vue&type=template&id=db8e73b2&scoped=true"
import script from "./WithdrawalPopup.vue?vue&type=script&lang=js"
export * from "./WithdrawalPopup.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalPopup.vue?vue&type=style&index=0&id=db8e73b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8e73b2",
  null
  
)

export default component.exports